export default __webpack_public_path__ + "static/media/jacuzzi.73d74589.svg";